import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import WysiwygInput from "../../../components/Form/Inputs/WysiwygInput"

const NewsDescription: FunctionComponent = () => {
  return (
    <>
      <Controller as={WysiwygInput} name="description" />
    </>
  )
}

export default NewsDescription
